import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { GlobalStateContext } from "../context/GlobalStateContext";
import ConsultationDetailForm from "../../screen/telemedicine/ConsultationDetailForm";

/**
 * Guard untuk route /consultation/detail-form.
 * Jika customer masih punya chat aktif (topicId di context), redirect ke halaman chat.
 * Dengan begitu user tidak bisa buka form konsultasi baru selama chat masih berlangsung.
 */
const ConsultationDetailFormGuard = () => {
  const { topicId } = useContext(GlobalStateContext);

  if (topicId && topicId.trim() !== "") {
    return (
      <Navigate
        to={`/consultation/chat-with-doctor/${topicId}`}
        state={{ type: 2 }}
        replace
      />
    );
  }

  return <ConsultationDetailForm />;
};

export default ConsultationDetailFormGuard;
